import { styled } from "@mui/material/styles"

import Column from "../../../../../common/components/Column"

export default styled(Column)(({ theme }) => ({
  position: "relative",
  overflowY: "auto",
}))
